export class WidgetSingleSerie {
    name: string;
    values: number[] = [];

    fillFromJson(data: any) {
        this.name = data.Name;
        this.values = [...data.Values];
    }

    move(fromIdx: number, toIdx: number) {
        // console.log(`merge in serie, from idx ${fromIdx} to ${toIdx}`);

        if (this.values[toIdx]) this.values[toIdx] += this.values[fromIdx];
        else this.values[toIdx] = this.values[fromIdx];

        this.values[fromIdx] = undefined;
        // console.log(`this.values`, this.values);
    }

    removeUndefinedValues() {
        this.values = this.values.filter((c) => c != undefined);
    }
}
